import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
// tslint:disable-next-line: max-line-length
import { SelecionarExtratoImportacao, Importacao, SelecionarExtratoImportacaoCabecalho, SelecionarExtratoImportacaoDetalhe, RequisicaoExtratoImportacaoDetalhe } from 'src/app/@shared/models/extrato-importacao.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})

export class ExtratoImportacaoService {

  constructor(private http: HttpClient) { }

  SelecionarExtratoImportacao(obj: any): Observable<HttpResponse<Importacao[]>> {
    return this.http
      .post<Importacao[]>(
        `EstoqueExtrato/SelecionarExtratoImportacao`,
        obj,
        { observe: 'response' }
      );
  }

  SelecionarExtratoImportacaoDetalhe(req: RequisicaoExtratoImportacaoDetalhe):
    Observable<HttpResponse<SelecionarExtratoImportacaoDetalhe[]>> {
    return this.http
      .get<SelecionarExtratoImportacaoDetalhe[]>(
        // tslint:disable-next-line: max-line-length
        `EstoqueExtrato/SelecionarExtratoImportacaoDetalhe/${req.LoteId}?paginaAtual=${req.paginaAtual + 1}&itensPorPagina=${req.itensPorPagina}`,
        { observe: 'response' }
      );
  }

  SelecionarExtratoImportacaoCabecalho(loteId: any):
    Observable<SelecionarExtratoImportacaoCabecalho> {
    return this.http
      .get<SelecionarExtratoImportacaoCabecalho>(
        `EstoqueExtrato/SelecionarExtratoImportacaoCabecalho/${loteId}`,
        httpOptions
      );
  }
}
